var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#FF1717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7125 23.5C21.1 23.5 19.5283 23.1438 17.9973 22.4313C16.4662 21.7188 15.11 20.7687 13.9285 19.5812C12.747 18.3937 11.797 17.0343 11.0785 15.5027C10.36 13.9712 10.0005 12.3995 10 10.7875V10.3938C10 10.2563 10.0125 10.125 10.0375 10H14.425L15.1187 13.7687L12.9812 15.925C13.5062 16.825 14.1658 17.6687 14.9598 18.4562C15.7538 19.2437 16.6255 19.925 17.575 20.5L19.75 18.325L23.5 19.075V23.4625C23.375 23.475 23.2438 23.4845 23.1063 23.491C22.9688 23.4975 22.8375 23.5005 22.7125 23.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerCall);
export default __webpack_public_path__ + "static/media/customerCall.dc472fbd9a4a4b2504875493178db233.svg";
export { ForwardRef as ReactComponent };